import { render, staticRenderFns } from "./QueryCard.vue?vue&type=template&id=712c6b2a&scoped=true"
import script from "./QueryCard.vue?vue&type=script&lang=js"
export * from "./QueryCard.vue?vue&type=script&lang=js"
import style0 from "./QueryCard.vue?vue&type=style&index=0&id=712c6b2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c6b2a",
  null
  
)

export default component.exports